import React, { useState } from 'react';
import { isNull } from 'lodash';
import map from 'lodash/map';
import StarRating from './rating';
import DownArrow from '../images/DownArrow';
import UpArrow from '../images/UpArrow';

import Selector from './selector'
import ThumbFavIcon from '../images/ThumbFavIcon';

const FeaturedMetadata = (props) => {
  const [state, setState] = useState({
    showDropdown: false
  })



  const rederPrimaryMetaDeta = (primaryMetaData, rating) => {
    return (
      <ul className="featuredMetadata">
        {
          map(primaryMetaData, (item, index) => {
            return (
              <li key={index}>{item.title}<span>{(isNull(item.value)) ? '-' : item.value}</span></li>
            )
          })
        }

        {
          <li>
            <div className="recipe-favorite-count">
              <ThumbFavIcon></ThumbFavIcon>
              Likes
              <span>{props.favoriteCount}</span>
            </div>
          </li>
        }
      </ul >
    )
  }

  const rederSecondaryMetaData = (secondaryMetaData) => {
    return (
      <div className="nutritions">
        <h6
          onClick={() => setState(prevState => ({ ...prevState, showDropdown: !state.showDropdown }))}>
          {state.showDropdown ? 'Hide' : 'Show'} {secondaryMetaData.title}
          {state.showDropdown ? <UpArrow /> : <DownArrow />}
        </h6>
        {
          state.showDropdown &&
          <div className="showFullNutrition">
            {map(secondaryMetaData.items, (item, index) => {
              return (
                <li className="nutritionsList" key={index}>
                  <p>{item.item}</p>
                  {
                    item.amount && <p className="nutritionAmount">{item.amount}</p>
                  }
                </li>
              )
            })}
            {map(secondaryMetaData.additionalItems, (item, index) => {
              return (
                <li className="nutritionsList" key={index}>
                  <p>{item.item}</p>
                  {
                    item.amount && <p className="nutritionAmount">{item.amount}</p>
                  }
                </li>
              )
            })}
          </div>
        }
      </div>
    )
  }

  return (
    <>
      {
        rederPrimaryMetaDeta(props.primaryMetaData, props.rating)
      }
      {
        rederSecondaryMetaData(props.secondaryMetaData)
      }
    </>
  )
}
export default FeaturedMetadata;